'use client'

import { useEffect } from 'react'
import { signIn, useSession } from '@/shared/ui/providers/AuthSessionProvider'
import { useRouter, useSearchParams, useTranslations } from '@/lib/next-shim'
import { sanitizeCallbackUrl } from '@/utils/auth'

export function LoginPage() {
  const router = useRouter()
  const searchParams = useSearchParams()
  const { status } = useSession()
  const t = useTranslations('common')
  const callbackUrl = sanitizeCallbackUrl(searchParams?.get('callbackUrl'))

  useEffect(() => {
    if (status === 'authenticated') {
      // No profile gate at login — patients browse and book freely. Profile completion
      // (incl. NIR for France billing) is enforced only at the video-consultation entry
      // (see the waiting-room gate). A soft banner nudges completion on the dashboard.
      router.replace(callbackUrl)
    } else if (status === 'unauthenticated') {
      signIn('keycloak', { callbackUrl })
    }
  }, [status, callbackUrl, router])

  if (status === 'loading') {
    return <div>{t('loading')}</div>
  }

  return null
}
